import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "vw-textarea",
  templateUrl: "./textarea.component.html",
})
export class TextareaComponent {
  @Input() placeholder?: string;
  @Input() formControlProp?: string | number;
  @Input({ required: true }) parentForm!: FormGroup;
  @Input() rows?: number;
  constructor() {}
}
